// #4 Termo de Declaração (FP-CMP-007) — registro do depoimento de UMA oitiva.
// Como o Plano (FP-CMP-010), fica FORA do registry dos 5 de botão: precisa de
// conteúdo DECIFRADO (ata = depoimento, presentes), não cabe no fluxo puro-metadado.
//
// Um termo POR Oitiva (não por dispensa — ADR/decisão 2026-06-29: dispensa não gera
// Termo de Declaração). O cabeçalho é metadado automático; o corpo (presentes +
// depoimento) é decifrado pelo chamador (withCaseDek) e passado em DeclaracaoData.

import type { FormBlock } from './form-pdf.js';
import { manualField } from './form-pdf.js';
import {
  type FormInput,
  categoriaLabel,
  competenciaLabel,
  fmtDate,
  memberLabel,
} from './forms-common.js';

/** Conteúdo DECIFRADO + metadado da oitiva-alvo (o chamador resolve via withMemberDek). */
export interface DeclaracaoData {
  /** Depoimento decifrado (ata da oitiva). Vazio → linha de preenchimento manual. */
  depoimento: string;
  /** Presentes decifrados (nomes/cargos). Vazio → linha de preenchimento manual. */
  presentes: string;
  /** Oitiva.registeredAt — data do registro da oitiva (epoch-ms). */
  dataOitiva: number;
  /** Oitiva.registeredBy — ulid do membro que registrou (rotulado via input.members). */
  registranteUlid: string;
}

export function buildDeclaracao(input: FormInput, decl: DeclaracaoData): FormBlock[] {
  const blocks: FormBlock[] = [
    { kind: 'title', text: 'Termo de Declaração' },
    { kind: 'field', label: 'Código:', value: 'FP-CMP-007' },

    // 1. Identificação — metadados automáticos do caso/oitiva.
    { kind: 'section', text: '1. Identificação' },
    { kind: 'field', label: 'Processo (protocolo):', value: input.caseId },
    { kind: 'field', label: 'Categoria:', value: categoriaLabel(input.categoria) },
    { kind: 'field', label: 'Comitê de competência:', value: competenciaLabel(input.categoria) },
    { kind: 'field', label: 'Data da oitiva:', value: fmtDate(decl.dataOitiva) },
    {
      kind: 'field',
      label: 'Registrado por:',
      value: memberLabel(input.members, decl.registranteUlid),
    },

    // 2. Presentes — decifrado (attendees). Vazio → manual.
    { kind: 'section', text: '2. Presentes na oitiva' },
  ];

  if (decl.presentes.trim() === '') {
    blocks.push(manualField('Presentes (nome / cargo):'));
  } else {
    blocks.push({ kind: 'paragraph', text: decl.presentes });
  }

  // 3. Declaração / depoimento — decifrado (ata). Vazio → manual.
  blocks.push({ kind: 'section', text: '3. Declaração' });
  if (decl.depoimento.trim() === '') {
    blocks.push(manualField('Depoimento prestado:'));
  } else {
    blocks.push({ kind: 'paragraph', text: decl.depoimento });
  }

  // 4. Encerramento — assinaturas (declarante + comitê).
  blocks.push(
    { kind: 'section', text: '4. Encerramento' },
    {
      kind: 'paragraph',
      text:
        'Declaro que o conteúdo acima reproduz fielmente o que foi prestado nesta oitiva, ' +
        'conduzida sob sigilo e com observância da ampla defesa (Lei 14.457/2022, art. 5º).',
    },
    { kind: 'spacer', mm: 6 },
    { kind: 'signature', nome: '', papel: 'Declarante' },
    { kind: 'signature', nome: '', papel: 'Membro do comitê de apuração' },
  );

  return blocks;
}
